import React, { useState, useEffect,useRef  } from 'react';
import {
  Button,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Checkbox,
  RadioGroup,
  Radio,
  FormControlLabel,
  
  Typography,
  Box,
  Grid,Stack,
  Paper,
} from '@mui/material';


import axiosApi from '../Utils/axiosApi';
import checkPermission from '../Utils/checkPermission';
const applicantTypes = [
  'Student',
  'Working Professional',
  'Freelancer',
  'Intern',
  'Researcher',
  'Other',
];


	  
	  const CreateHostler = ({ onClose = () => {}, hosteler = {} }) => {
  const [formData, setFormData] = useState({
    hostelId: hosteler.hostelId || '',
        userId: hosteler.userId || '',
		id: hosteler.id || '',
        gender: hosteler.gender || '',
        dob: hosteler.dob ? hosteler.dob.split('T')[0] : '',
        roomType: hosteler.roomType || '',
        roomNumber: hosteler.roomNumber || '',
        hostelJoinDate: hosteler.hostelJoinDate ? hosteler.hostelJoinDate.split('T')[0] : '',
        guardianName: hosteler.guardianName || '',
        guardianContactNumber: hosteler.guardianContactNumber || '',
        emergencyContactName: hosteler.emergencyContactName || '',
        emergencyContactNumber: hosteler.emergencyContactNumber || '',
        hostelCheckOutDate: hosteler.hostelCheckOutDate ? hosteler.hostelCheckOutDate.split('T')[0] : '',
        idProofName: hosteler.idProofName || '',
        idProofNumber: hosteler.idProofNumber || '',
        idProofDocName: hosteler.idProofDocName || '',
        cityId: hosteler.cityId || '',
        applicantType: hosteler.applicantType || '',
        mobileNumber: hosteler.mobileNumber || '',
        hostlerFirstName: hosteler.hostlerFirstName || '',
        hostlerLastName: hosteler.hostlerLastName || '',
        email: hosteler.email || '',
		depositAmount: hosteler.depositAmount || '',
        address: hosteler.address || '',
        countryId: hosteler.countryId || '',
        stateId: hosteler.stateId || '',
        districtId: hosteler.districtId || '',
        associatedOrganization: hosteler.associatedOrganization || '',
        accommodationType: hosteler.accommodationType || '',
        stayType: hosteler.stayType || '',
		foodPrice: hosteler.foodPrice || '',
		rentPrice: hosteler.rentPrice || '',
		bookingId: hosteler.bookingId || '',
		activeHosteler: hosteler.activeHosteler === "N" ? false : true,
		
		tenantLoginId: hosteler.tenantLoginId || '',
		
  });

  const [hostelList, setHostelList] = useState([]);
  const [roomTypes, setRoomTypes] = useState([]);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [cities, setCities] = useState([]);
  const [roomNumbers, setRoomNumbers] = useState([]);
const [roomsLoading, setRoomsLoading] = useState(false);
  const alertRef = useRef(null);
 const [banner, setBanner] = useState({
    open: false,
    type: '',
    message: '',
  });
  const handleInputChange = (e) => {
  const { name, value } = e.target;

  setFormData((prev) => {
    let updated = { ...prev, [name]: value };

    // ✅ Auto-fill ONLY if user hasn’t manually changed it
    if (name === "mobileNumber") {
      if (
        !prev.tenantLoginId ||
        prev.tenantLoginId === prev.mobileNumber
      ) {
        updated.tenantLoginId = value;
      }
    }

    return updated;
  });
};

  const handleFileChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      uploadDocument: e.target.files[0],
    }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  
  if (formData.accommodationType !== "FOOD_ONLY" && !formData.roomType) {
    setBanner({
      open: true,
      type: "error",
      message: "Room Type is required unless selecting 'Only food (no accommodation)'.",
    });
    return;
  }



  const isUpdate = hosteler && hosteler.id;
  const endpoint = isUpdate ? '/hosteler/updateHosteler' : '/hosteler/createHosteler';

  // Build payload
  let payload = { hostelerDTO: { ...formData,
rentPrice: formData.rentPrice || null,
    foodPrice: formData.foodPrice || null
	} };
  payload.hostelerDTO.activeHosteler = formData.activeHosteler ? "Y" : "N";
  if (isUpdate) {
    payload.hostelerDTO.id = hosteler.id;
    payload.hostelerDTO.userId = hosteler.userId; // or wherever you get userId from
  }

  try {
    await axiosApi.post(endpoint, payload);
    console.log('Saved successfully');
    setBanner({
        open: true,
        type: 'success',
        message: isUpdate
          ? 'Hosteler updated successfully!'
          : 'Hosteler created successfully!',
      });
  } catch (err) {
    console.error(err);
    setBanner({
        open: true,
        type: 'error',
        message: err?.response?.data?.message || 'Error saving hosteler',
      });
  }
};





  

  useEffect(() => {
    axiosApi
      .post('/hostel/getHostelName', {})
      .then((response) => {
        const data = Array.isArray(response.data)
          ? response.data
          : response.data.hostels || [];
        const formatted = data.map(([id, name]) => ({ id, hostelName: name }));
        setHostelList(formatted);
      })
      .catch((error) => console.error('Error fetching hostels:', error));
  }, []);

  useEffect(() => {
    axiosApi
      .post('/hostel/getHostelRoomType', {})
      .then((response) => {
        const roomTypeArray = Array.isArray(response.data)
          ? response.data
          : response.data.roomTypes || [];
        setRoomTypes(roomTypeArray);
      })
      .catch((error) => {
        console.error('Error fetching room types:', error);
      });
  }, []);

useEffect(() => {
    axiosApi.post('/hostel/getHostelName', {}).then((response) => {
      const data = Array.isArray(response.data) ? response.data : response.data.hostels || [];
      const formatted = data.map(([id, name]) => ({ id, hostelName: name }));
      setHostelList(formatted);
    });

   
  }, []);

useEffect(() => {
  if (banner.open) {
    setTimeout(() => {
      alertRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
      alertRef.current?.focus();
    }, 100);
  }
}, [banner]);


  // LOAD ROOM TYPES BASED ON hostelId
  // --------------------------
 useEffect(() => {
  if (!formData.hostelId) {
    setRoomTypes([]);
    return;
  }

  axiosApi
    .post("/hostel/getHostelRoomType", {
      hostelSearchCriteria: { hostelIds: [formData.hostelId] }
    })
    .then((response) => {
      const data = Array.isArray(response.data)
        ? response.data
        : response.data.roomTypes || [];

      setRoomTypes(data);
    })
    .catch((error) => {
      console.error("Error fetching room types:", error);
      setRoomTypes([]);
    });
}, [formData.hostelId]);
useEffect(() => {
  if (!hosteler.id) {
    // Create mode → reset roomType when hostel changes
    setFormData(prev => ({ ...prev, roomType: '' }));
  } else {
    // Update mode → keep the saved room type
    setFormData(prev => ({
      ...prev,
      roomType: hosteler.roomType || prev.roomType || ''
    }));
  }
}, [formData.hostelId, hosteler.id, hosteler.roomType]);




useEffect(() => {
  const loadRoomNumbers = async () => {
    if (
      !formData.hostelId ||
      !formData.roomType ||
      formData.accommodationType === "FOOD_ONLY"
    ) {
      setRoomNumbers([]);
      return;
    }

    setRoomsLoading(true);

    try {
      const response = await axiosApi.post("/public/getHostelRoom", {
        hostelSearchCriteria: {
          hostelIds: [Number(formData.hostelId)],
          roomType: formData.roomType,
        },
      });

      const payload = response?.data;
      const rooms = Array.isArray(payload)
        ? payload
        : payload?.rooms || payload?.data || [];

      const numbers = [
        ...new Set(
          rooms
            .filter(
              (room) => room.roomType === formData.roomType
            )
            .flatMap((room) =>
              String(room.roomNumber || "")
                .split(",")
                .map((number) => number.trim())
                .filter(Boolean)
            )
        ),
      ];

      // Keep the existing room number available in update mode.
      const existingRoomNumber = String(
        hosteler?.roomNumber || ""
      ).trim();

      if (
        existingRoomNumber &&
        !numbers.includes(existingRoomNumber) &&
        String(hosteler?.roomType || "") ===
          String(formData.roomType)
      ) {
        numbers.unshift(existingRoomNumber);
      }

      setRoomNumbers(numbers);
    } catch (error) {
      console.error("Error fetching room numbers:", error);
      setRoomNumbers([]);
    } finally {
      setRoomsLoading(false);
    }
  };

  loadRoomNumbers();
}, [
  formData.hostelId,
  formData.roomType,
  formData.accommodationType,
  hosteler?.roomNumber,
  hosteler?.roomType,
]);
  
  useEffect(() => {
    axiosApi.post('/country/getCountry', {}).then((response) => {
      const data = Array.isArray(response.data)
        ? response.data
        : response.data.countries || [];

      setCountries(data);
    });
  }, []);
  useEffect(() => {
    if (formData.countryId) {
      axiosApi.post('/state/getState', { countryIds: [formData.countryId] }).then((response) => {
        const data = Array.isArray(response.data) ? response.data : response.data.states || [];
        setStates(data);
      });
    } else {
      setStates([]);
    }
  }, [formData.countryId]);

  useEffect(() => {
    if (formData.stateId) {
      axiosApi.post('/district/getDistrict', { stateIds: [formData.stateId] }).then((response) => {
        const data = Array.isArray(response.data) ? response.data : response.data.districts || [];
        setDistricts(data);
      });
    } else {
      setDistricts([]);
    }
  }, [formData.stateId]);

  useEffect(() => {
    if (formData.districtId) {
      axiosApi.post('/city/getCity', { districtIds: [formData.districtId] }).then((response) => {
        const data = Array.isArray(response.data) ? response.data : response.data.cities || [];
        setCities(data);
      });
    } else {
      setCities([]);
    }
  }, [formData.districtId]);

useEffect(() => {
  if (hosteler && hosteler.accommodationType) {
    setFormData((prev) => ({ ...prev, accommodationType: hosteler.accommodationType }));
  }
}, [hosteler]);

useEffect(() => {
  setFormData(prev => {
    if (prev.accommodationType === "FOOD_ONLY") {
      return {
        ...prev,
        roomType: "",
        roomNumber: "",
        rentPrice: ""
      };
    }

    if (prev.accommodationType === "STAY_ONLY") {
      return {
        ...prev,
        foodPrice: ""
      };
    }

    return prev; // STAY_WITH_FOOD
  });
}, [formData.accommodationType]);

const isFoodOnly = formData.accommodationType === "FOOD_ONLY";
const isStayOnly = formData.accommodationType === "STAY_ONLY";


  return (
    <div>
      
      <Paper elevation={3} className="create-hostler-container">
        
{/* Banner */}
       {banner.open && (
  <Box
    ref={alertRef}
    tabIndex={-1}
    sx={{
      backgroundColor:
        banner.type === 'success' ? '#d4edda' : '#f8d7da',
      color: banner.type === 'success' ? '#155724' : '#721c24',
      border: `1px solid ${
        banner.type === 'success' ? '#c3e6cb' : '#f5c6cb'
      }`,
      padding: '10px 20px',
      textAlign: 'center',
      borderRadius: '4px',
      marginBottom: '16px',
      outline: "none"
    }}
  >
    {banner.message}
  </Box>
)}

        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            {/* Hostel Name */}
            <Grid item xs={12} sm={6}>
  <FormControl fullWidth required>
    <InputLabel>Hostel Name</InputLabel>
    <Select
      name="hostelId"
      value={formData.hostelId}
      onChange={handleInputChange}
      label="Hostel Name"
    >
      {hostelList.map((hostel) => (
        <MenuItem key={hostel.id} value={hostel.id}>
          {hostel.hostelName}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</Grid>


            <Grid item xs={12} sm={6}>
              <TextField
                label="Booking ID"
                name="bookingId"
                value={formData.bookingId}
                onChange={handleInputChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                label="First Name"
                name="hostlerFirstName"
                value={formData.hostlerFirstName}
                onChange={handleInputChange}
                fullWidth required
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                label="Last Name"
                name="hostlerLastName"
                value={formData.hostlerLastName}
                onChange={handleInputChange}
                fullWidth required
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Gender</InputLabel>
                <Select name="gender" value={formData.gender} onChange={handleInputChange} label="Gender">
                  <MenuItem value="Male">Male</MenuItem>
                  <MenuItem value="Female">Female</MenuItem>
                  <MenuItem value="Other">Other</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                label="Date of Birth"
                type="date"
                name="dob"
                value={formData.dob}
                onChange={handleInputChange}
                InputLabelProps={{ shrink: true }}
				
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                label="Mobile Number"
                name="mobileNumber"
                value={formData.mobileNumber}
                onChange={handleInputChange}
                required
                fullWidth
              />
            </Grid>
			<Grid item xs={12} sm={6}>
              <TextField
				  label="Tenant Login ID"
				  name="tenantLoginId"
				  value={formData.tenantLoginId}
				  onChange={handleInputChange}
				  helperText="Default is mobile number. You can change it."
				  required
				  fullWidth
				/>
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                label="Email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth required={!isFoodOnly}>
                <InputLabel>Room Type</InputLabel>
                <Select
				  name="roomType"
				  value={formData.roomType}
				  onChange={(event) => {
  const roomType = event.target.value;

  setFormData((prev) => ({
    ...prev,
    roomType,
    roomNumber: "",
  }));
}}
				  label="Room Type"
				  disabled={isFoodOnly}
				>

                  {roomTypes.map((rt) => (
                    <MenuItem key={rt.id} value={rt.roomType}>
                      {rt.roomType}
                    </MenuItem>
                  ))}
				  
                </Select>
				
              </FormControl>
            </Grid>

           
<Grid item xs={12} sm={6}>
  <FormControl
    fullWidth
    disabled={isFoodOnly || roomsLoading || !formData.roomType}
  >
    <InputLabel id="room-number-label">
      Room Number
    </InputLabel>

    <Select
      labelId="room-number-label"
      name="roomNumber"
      label="Room Number"
      value={formData.roomNumber ?? ""}
      onChange={handleInputChange}
    >
      {roomNumbers.map((number) => (
        <MenuItem key={number} value={number}>
          {number}
        </MenuItem>
      ))}
    </Select>

    {roomsLoading && (
      <Typography variant="caption" color="text.secondary">
        Loading room numbers...
      </Typography>
    )}
  </FormControl>
</Grid>

			
			<Grid item xs={12} sm={6}>
  <TextField
    label="Rent Price"
    name="rentPrice"
    type="number"
    value={formData.rentPrice}
    onChange={handleInputChange}
    fullWidth
    disabled={isFoodOnly}
  />
</Grid>
<Grid item xs={12} sm={6}>
  <TextField
    label="Food Price"
    name="foodPrice"
    type="number"
    value={formData.foodPrice}
    onChange={handleInputChange}
    fullWidth
    disabled={isStayOnly}
  />
</Grid>
<Grid item xs={12} sm={6}>
  <TextField
    label="Deposit Amount"
    name="depositAmount"
    type="number"
    value={formData.depositAmount}
    onChange={handleInputChange}
    fullWidth
    
  />
</Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                label="Check-in Date"
                type="date"
                name="hostelJoinDate"
                value={formData.hostelJoinDate}
                onChange={handleInputChange}
                InputLabelProps={{ shrink: true }}
                fullWidth required
              />
            </Grid>

<Grid item xs={12} sm={6}>
              <TextField
                label="Check-out Date"
                type="date"
                name="hostelCheckOutDate"
                value={formData.hostelCheckOutDate}
                onChange={handleInputChange}
                InputLabelProps={{ shrink: true }}
                fullWidth required
              />
            </Grid>
			
			<Grid item xs={12}>
 <FormControlLabel
  control={
    <Checkbox
      checked={formData.activeHosteler}
      onChange={(e) =>
        setFormData((prev) => ({ ...prev, activeHosteler: e.target.checked }))
      }
    />
  }
  label="Active User"
/>

</Grid>

			
            <Grid item xs={12} sm={6}>
              <TextField
                label="Emergency Contact Name"
                name="emergencyContactName"
                value={formData.emergencyContactName}
                onChange={handleInputChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                label="Emergency Contact Number"
                name="emergencyContactNumber"
                value={formData.emergencyContactNumber}
                onChange={handleInputChange}
                
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>ID Proof Type</InputLabel>
                <Select
                  name="identityProof"
                  value={formData.identityProof}
                  onChange={handleInputChange}
                  label="ID Proof Type"
                >
                  <MenuItem value="Aadhar">Aadhar</MenuItem>
                  <MenuItem value="Passport">Passport</MenuItem>
                  <MenuItem value="Driving License">Driving License</MenuItem>
                  <MenuItem value="PAN Card">PAN Card</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                label="ID Proof Number"
                name="idProofNumber"
                value={formData.idProofNumber}
                onChange={handleInputChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                label="Parent Name"
                name="guardianName"
                value={formData.guardianName}
                onChange={handleInputChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                label="Parent Phone Number"
                name="guardianContactNumber"
                value={formData.guardianContactNumber}
                onChange={handleInputChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12}>
  <FormControl required>
    <Typography variant="subtitle1">
      Accommodation Type <span style={{ color: "red" }}>*</span>
    </Typography>
    <RadioGroup
      row
      name="accommodationType"
      value={formData.accommodationType || ""}  // ✅ fallback to "" so React doesn't complain
      onChange={handleInputChange}
      required
    >
      <FormControlLabel
        value="STAY_ONLY"
        control={<Radio />}
        label="Hostel stay without food"
      />
      <FormControlLabel
        value="STAY_WITH_FOOD"
        control={<Radio />}
        label="Hostel stay with meals included"
      />
      <FormControlLabel
        value="FOOD_ONLY"
        control={<Radio />}
        label="Only food (no accommodation)"
      />
    </RadioGroup>
  </FormControl>
</Grid>


            <Grid item xs={12} sm={6}>
              <FormControl fullWidth required>
                <InputLabel>Hostler Stay Type</InputLabel>
                <Select
                  name="stayType"
                  value={formData.stayType}
                  onChange={handleInputChange}
                  label="Hostler Stay Type"
                >
                  <MenuItem value="DAILY">Daily</MenuItem>
                  <MenuItem value="MONTHLY">Monthly</MenuItem>
                  
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Applicant Type</InputLabel>
                <Select
                  name="applicantType"
                  value={formData.applicantType}
                  onChange={handleInputChange}
                  label="Applicant Type"
                >
                  {applicantTypes.map((type) => (
                    <MenuItem key={type} value={type}>
                      {type}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                label="Associated Organization"
                name="associatedOrganization"
                value={formData.associatedOrganization}
                onChange={handleInputChange}
                fullWidth
              />
            </Grid>

          {/* Country Dropdown */}
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth >
            <InputLabel>Country</InputLabel>
            <Select name="countryId" value={formData.countryId} onChange={handleInputChange}>
              {countries.map((country) => (
                <MenuItem key={country.id} value={country.id}>{country.countryName}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {/* State Dropdown */}
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth >
            <InputLabel>State</InputLabel>
            <Select name="stateId" value={formData.stateId} onChange={handleInputChange}>
              {states.map((state) => (
                <MenuItem key={state.id} value={state.id}>{state.stateName}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {/* District Dropdown */}
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel>District</InputLabel>
            <Select name="districtId" value={formData.districtId} onChange={handleInputChange}>
              {districts.map((district) => (
                <MenuItem key={district.id} value={district.id}>{district.districtName}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {/* City Dropdown */}
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth >
            <InputLabel>City</InputLabel>
            <Select name="cityId" value={formData.cityId} onChange={handleInputChange}>
              {cities.map((city) => (
                <MenuItem key={city.id} value={city.id}>{city.cityName}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>




            <Grid item xs={12}>
              <TextField
                label="Address"
                name="address"
                value={formData.address}
                onChange={handleInputChange}
                multiline
                rows={2}
                fullWidth
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body1">Upload ID Proof Document (Optional)</Typography>
              <input type="file" onChange={handleFileChange} />
            </Grid>

           <Grid item xs={12}>
  <Stack
    direction={{ xs: 'column', sm: 'row' }}  // ✅ column on mobile, row on larger screens
    spacing={2}
    justifyContent={{ xs: 'center', sm: 'flex-end' }} // ✅ center buttons on mobile
    alignItems={{ xs: 'stretch', sm: 'center' }} // ✅ make full width buttons on mobile
  >
    <Button disabled={!checkPermission("Hostel", "Hosteler List", "UPDATE")}
      type="submit"
      variant="contained"
      color="primary"
      fullWidth={{ xs: true, sm: false }} // ✅ full width only on mobile
    >
      {hosteler ? 'Update Hosteler' : 'Create Hosteler'}
    </Button>

    <Button
      onClick={onClose}
      variant="outlined"
      color="secondary"
      sx={{ minWidth: 140 }}
      fullWidth={{ xs: true, sm: false }} // ✅ full width on mobile
    >
      Close
    </Button>
  </Stack>
</Grid>


          </Grid>
        </form>
      </Paper>
    </div>
  );
};

export default CreateHostler;